/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback, useEffect, useState} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {ServiceError} from '@ion/core/src/types/services';
import {IonSnackbar} from '@ion/dls/src/notifications/IonSnackbar';

// defines the Error Prop type definitions ...
export interface ErrorProps {
  error?: ServiceError | null;
  label?: string;
}

/**
 * @Error
 *
 * The Error provides the UI for closing an snack bar.
 *
 * ```typescript
 *
 *    import {Error} from '@ion/ion-ctc-admin/src/jobs';
 *
 *    <Error label={label}
 *      error={error} />
 *
 * ```
 *
 * @param {boolean}       error Throws error when cancellation failed.
 * @param {string}        label A reference to the label If the cancellation succes.
 */
export const Error = ({
  error,
  label
}: ErrorProps) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    error && setShowError(true);
  }, [error]);

  const close = useCallback(function() {
    setShowError(false);
  }, []);

  if (showError) {
    return (
      <>
        <IonSnackbar show={showError}
          message={translate('downloadjobs:delete.failure', {label})}
          actionLabel={translate('notifications:warning.actionLabel')}
          onClose={close}
          onAction={close} />
      </>
    );
  }
  return null;
};

export default Error;
